import { GetFullAgencyByIdResponseBodyType } from "@intelligems/ig-types/functions/agencies";
import { adminKeys } from "@src/api/queryKeys";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { api } from "../api";

const getFullAgencyById = async (id: string) => {
  const resp = await api.get<GetFullAgencyByIdResponseBodyType>(
    `/v2/admin/agencies/${id}`
  );
  return resp.data;
};

export const useGetFullAgencyById = (
  id: string
): UseQueryResult<GetFullAgencyByIdResponseBodyType, Error> => {
  return useQuery<GetFullAgencyByIdResponseBodyType, Error>({
    queryKey: adminKeys.agency(id),
    queryFn: async () => getFullAgencyById(id),
    enabled: !!id,
  });
};
